/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:4313e2ef-00ae-447f-b1ff-a46c412d8938",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_GmNRjL645",
    "aws_user_pools_web_client_id": "6qtcvemn4bf2jdrm21ir8lcte8",
    "oauth": {
        "domain": "taidacorp-prod.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://app.taidacorp.com/auth/,http://localhost:3000/auth/,http://localhost:3000/auth/",
        "redirectSignOut": "https://app.taidacorp.com/auth/,http://localhost:3000/auth/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [
        "GOOGLE"
    ],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ]
};


export default awsmobile;
